const FinishesCardsLayout = () => {
  const finishesCards = [...document.querySelectorAll(".finishes__item-container")];

  const updateLayoutForVisibleCards = () => {
    finishesCards.forEach((finishesCard) => {
      if (finishesCard.offsetParent === null) {
        return;
      }

      const mainBlock = finishesCard.querySelector(".finishes__item-main");
      const contentBlock = finishesCard.querySelector(".finishes__item-content");
      const footerBlock = finishesCard.querySelector(".finishes__item-footer");
      const readMoreBtn = finishesCard.querySelector(".read-more-btn");
      const parentItem = finishesCard.closest(".finishes__item");
      const colorsBlock = finishesCard.querySelector(".finishes__item-colors-block");
      const colorsBlockBtn = colorsBlock ? colorsBlock.querySelector(".finishes__item-colors-btn") : null;

      if (!contentBlock || !readMoreBtn) {
        return;
      }

      const mainBlockStyles = window.getComputedStyle(mainBlock);
      const readMoreBtnStyles = window.getComputedStyle(readMoreBtn);
      const finishesCardStyles = window.getComputedStyle(finishesCard);
      const paddingTop = parseFloat(mainBlockStyles.paddingTop);
      const paddingBottom = parseFloat(mainBlockStyles.paddingBottom);
      const gap = parseFloat(mainBlockStyles.gap) || 0;

      const padding = paddingTop + paddingBottom;
      const maxHeight = parseFloat(finishesCardStyles.height);
      const readMoreBtnHeight = parseFloat(readMoreBtnStyles.height);
      const footerHeight = footerBlock ? footerBlock.offsetHeight : 0;
      const availableHeight = maxHeight - padding - gap - footerHeight;
      let availableContentHeight = availableHeight;

      const contentHeight = contentBlock.scrollHeight;

      if (contentHeight > availableHeight) {
        availableContentHeight = availableHeight - readMoreBtnHeight;
        contentBlock.style.maxHeight = `${availableContentHeight}px`;
        contentBlock.style.overflow = "hidden";
        readMoreBtn.style.display = "flex";
      } else {
        contentBlock.style.maxHeight = "none";
        contentBlock.style.overflow = "visible";
        readMoreBtn.style.display = "none";
      }

      const newReadMoreBtn = readMoreBtn.cloneNode(true);
      readMoreBtn.parentNode.replaceChild(newReadMoreBtn, readMoreBtn);

      newReadMoreBtn.addEventListener("click", () => {
        finishesCard.classList.toggle("active");
        newReadMoreBtn.classList.toggle("active");

        const isActive = finishesCard.classList.contains("active");

        if (isActive) {
          contentBlock.style.maxHeight = "fit-content";

          if (parentItem) {
            parentItem.classList.add("opened");
          }
        } else {
          contentBlock.style.maxHeight = `${availableContentHeight}px`;

          if (parentItem) {
            parentItem.classList.remove("opened");
          }
        }

        if (colorsBlock && colorsBlock.classList.contains("opened")) {
          colorsBlock.classList.remove("opened");
        }
      });

      if (colorsBlockBtn) {
        colorsBlockBtn.addEventListener("click", () => {
          if (colorsBlock.classList.contains("opened")) {
            parentItem.classList.add("opened");
            contentBlock.style.maxHeight = `${availableContentHeight}px`;
            finishesCard.classList.remove("active");
            newReadMoreBtn.classList.remove("active");
          }
        });
      }
    });
  };

  updateLayoutForVisibleCards();

  window.addEventListener("resize", updateLayoutForVisibleCards);
  if(document.querySelector(".finishes__slider")){
    const sliderInstance = document.querySelector(".finishes__slider").swiper;
    if (sliderInstance) {
      sliderInstance.on("slideChange", () => {
        updateLayoutForVisibleCards();
      });
    }
  }
  
};

export default FinishesCardsLayout;